import * as yup from 'yup';
import { validateCpfCnpj } from '../../../shared/utils/functions';

export const schemaClient = yup.object().shape({
  corporate_name: yup.string().required('Nome obrigatório'),
  cpf_cnpj: yup
    .string()
    .required('CPF obrigatório')
    .test('test-invalid-cpf', 'cpf/cnpj inválido', (cpf) =>
      validateCpfCnpj(cpf),
    ),
  birthday: yup.string().required('Data de cadastro obrigatória'),
  cell_phone: yup.string().required('Celular obrigatório'),
  is_supplier: yup.boolean().required('É fornecedor obrigatório'),
});
